import DataRoomIsLockedCard from './DataRoomIsLockedCard.component';

export default DataRoomIsLockedCard;
